import { useSearchParams } from "react-router";
import { useAuth } from "@/contexts/auth-context";
import { getUserRole, type UserRole } from "@/types/auth";

const VIEWABLE_ROLES = new Set<string>([
	"district_manager",
	"reseller_manager",
	"reseller",
]);

export function useEffectiveRole(): UserRole | null {
	const { user } = useAuth();
	const [searchParams] = useSearchParams();

	if (!user) return null;

	const role = getUserRole(user);

	if (role === "admin") {
		const viewAs = searchParams.get("viewAs");
		if (viewAs && VIEWABLE_ROLES.has(viewAs)) {
			return viewAs as UserRole;
		}
		return "district_manager";
	}

	return role;
}
